import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/midders/Code/xedi-microservices/sdk-js/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import { CheckIcon } from '@primer/styled-octicons';
import { Box, Flex, Label } from '@primer/components';
import { H3 } from '@primer/gatsby-theme-doctocat/src/components/heading';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h2>{`Introduction`}</h2>
    <p>{`The Users API allows you to interact with our users data`}</p>
    <h2>{`Usage`}</h2>
    <h3>{`List`}</h3>
    <p>{`List all Users that the user has the authority to see withing the context of a Business`}</p>
    <p><strong parentName="p">{`Parameters`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Property`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Required`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Example`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`pageNumber`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`number`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`1`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Usage`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`const users = await Xedi.Users.list();
`}</code></pre>
    <p><strong parentName="p">{`Response`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`[
    {
        "_id": "e7e16998-3d2e-11ea-be36-01002da17977",
        "first_name": "Tony",
        "last_name": "Stark",
        "email": "TonyStark@Avengers.com",
        "contact_no": null,
        "job_title": null,
        "avatar": null,
        "is_active": "1",
        "created_at": "2010-07-03 13:34:10",
        "updated_at": "2019-07-03 15:15:10",
        "deleted_at": "2020-09-01 12:44:10"
    },
    {
        "_id": "96GE2a3e-boi0-11e9-b308-013533e48b37",
        "first_name": "Jeff",
        "last_name": "Goldblum",
        "email": "GoldenJeff@Avengers.com",
        "contact_no": null,
        "job_title": null,
        "avatar": null,
        "is_active": "1",
        "created_at": "2012-07-03 13:34:10",
        "updated_at": "2019-07-03 15:15:10",
        "deleted_at": "2020-09-01 12:44:10"
    }
]
`}</code></pre>
    <h3>{`Get`}</h3>
    <p>{`Retrieve a User by ID that the user has the authority to see within the context of a Business`}</p>
    <p><strong parentName="p">{`Parameters`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Property`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Required`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Example`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`user_id`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Xuid`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}><CheckIcon color="green.5" mdxType="CheckIcon" /></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`'e7e16998-3d2e-11ea-be36-01002da17977'`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Usage`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`const user = await Xedi.Users.get('e7e16998-3d2e-11ea-be36-01002da17977');
`}</code></pre>
    <p><strong parentName="p">{`Response`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
    "_id": "e7e16998-3d2e-11ea-be36-01002da17977",
    "first_name": "Tony",
    "last_name": "Stark",
    "email": "TonyStark@Avengers.com",
    "contact_no": null,
    "job_title": null,
    "avatar": null,
    "is_active": "1",
    "created_at": "2010-07-03 13:34:10",
    "updated_at": "2019-07-03 15:15:10",
    "deleted_at": "2020-09-01 12:44:10"
}
`}</code></pre>
    <h3>{`Get Permission`}</h3>
    <p>{`Retrieve a users Permissions`}</p>
    <p><strong parentName="p">{`Parameters`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Property`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Required`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Example`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`user_id`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`UUID`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}><CheckIcon color="green.5" mdxType="CheckIcon" /></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`f3ce14b8-b542-11ea-aded-01002da17977`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Usage`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const permissions = await Xedi.Users.getPermissions('0453b1ec-44d4-31d7-bffb-accfbaab2c90');
`}</code></pre>
    <p><strong parentName="p">{`Response`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
    "data": [
        {
            "Key": "audit.event.business.read",
            "is_hidden": 0
        },
        {
            "Key": "audit.event.read",
            "is_hidden": 0
        },
        {
            "Key": "audit.event.user.read",
            "is_hidden": 0
        }
    ]
}
`}</code></pre>
    <Flex alignItems="center" mdxType="Flex">
    <H3 mdxType="H3">Get By Group</H3>
    <Box mx="auto" mdxType="Box" />
    <Label bg="#A575FF" mdxType="Label">Pagination Enabled</Label>
    </Flex>
    <p>{`List all the users associated with a group.`}</p>
    <p><strong parentName="p">{`Parameters`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Property`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Required`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Example`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`group_id`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`UUID`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}><CheckIcon color="green.5" mdxType="CheckIcon" /></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`f3ce14b8-b542-11ea-aded-01002da17977`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`pageNumber`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`number`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`1`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Usage`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const users = await Xedi.Users.getByGroup('0453b1ec-44d4-31d7-bffb-accfbaab2c90');
`}</code></pre>
    <p><strong parentName="p">{`Response`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
    "current_page": 1,
    "data": [
        {
            "_id": "e7e16998-3d2e-11ea-be36-01002da17977",
            "first_name": "Tony",
            "last_name": "Stark",
            "email": "TonyStark@Avengers.com",
            "contact_no": null,
            "job_title": null,
            "avatar": null,
            "is_active": "1",
            "created_at": "2020-07-03 13:58:10",
            "updated_at": "2020-07-03 13:58:10",
            "deleted_at": "2020-09-01 13:58:10"
        }
    ],
    "first_page_url": "https://api.xedi.com/1/users?page=1",
    "from": 1,
    "last_page": "https://api.xedi.com/1/users?page=1",
    "last_page_url": null,
    "next_page_url": null,
    "path": "https://api.xedi.com/1/users",
    "per_page": 15,
    "prev_page_url": null,
    "to": 1,
    "total": 1
}
`}</code></pre>
    <h3>{`Update`}</h3>
    <p>{`Update a user by ID`}</p>
    <p><strong parentName="p">{`Parameters`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Property`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Required`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Example`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`_id`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Xuid`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}><CheckIcon color="green.5" mdxType="CheckIcon" /></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`'e7e16998-3d2e-11ea-be36-01002da17977'`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`first_name`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`String`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`'Tony'`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`last_name`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`String`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`'Stark'`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`email`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`String`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`'`}<a parentName="td" {...{
              "href": "mailto:TonyStark@Avengers.com"
            }}>{`TonyStark@Avengers.com`}</a>{`'`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`contact_no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`String`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`'01234 567890'`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`job_title`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`String`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`'CEO'`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`avatar`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`String`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`'`}<a parentName="td" {...{
              "href": "https://someurl.com/avatar'"
            }}>{`https://someurl.com/avatar'`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`is_active`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Integer`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`1`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Usage`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`    await Xedi.User.Update({
        "_id": "e7e16998-3d2e-11ea-be36-01002da17977",
        "first_name": "Tony",
        "last_name": "Stark",
        "email": "TonyStark@Avengers.com",
        "contact_no": "01234 567890",
        "job_title": "CEO",
        "avatar": "https://someurl.com/avatar",
        "is_active": "1",
    })
`}</code></pre>
    <p><strong parentName="p">{`Response`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
    "data": {
        "_id": "e7e16998-3d2e-11ea-be36-01002da17977",
        "first_name": "Tony",
        "last_name": "Stark",
        "email": "TonyStark@Avengers.com",
        "contact_no": "01234 567890",
        "job_title": "CEO",
        "avatar": "https://someurl.com/avatar",
        "is_active": "1",
        "created_at": "2020-09-03 14:00:00",
        "updated_at": "2020-09-07 15:00:00",
        "deleted_at": null
    }
}
`}</code></pre>
    <h3>{`Delete`}</h3>
    <p>{`Delete a user by ID`}</p>
    <p><strong parentName="p">{`Parameters`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Property`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Required`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Example`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`_id`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Xuid`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}><CheckIcon color="green.5" mdxType="CheckIcon" /></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`'e7e16998-3d2e-11ea-be36-01002da17977'`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Usage`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`await Xedi.User.delete('e7e16998-3d2e-11ea-be36-01002da17977');
`}</code></pre>
    <h3>{`Restore`}</h3>
    <p>{`Restore a soft deleted user by ID`}</p>
    <p><strong parentName="p">{`Parameters`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Property`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Required`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Example`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`_id`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Xuid`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}><CheckIcon color="green.5" mdxType="CheckIcon" /></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`'e7e16998-3d2e-11ea-be36-01002da17977'`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Usage`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`await Xedi.User.restore('e7e16998-3d2e-11ea-be36-01002da17977');
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      